import type { SalaryCurrency } from '@seek/salary-data/lib-types/types';

import type { DraftJobSalaryCurrency } from 'src/graphql/generated';

export const createGetPreviewCurrencyLabel = (
  convertCountryCodeToDefaultCurrency: (countryCode: string) => SalaryCurrency,
) => {
  const implementation = (
    salaryCurrency: DraftJobSalaryCurrency,
    jobLocationCountry: string,
  ): string | undefined => {
    const salaryCurrencyMatchesLocationDefault =
      salaryCurrency ===
      convertCountryCodeToDefaultCurrency(jobLocationCountry);

    const currencyLabel = salaryCurrencyMatchesLocationDefault
      ? undefined
      : salaryCurrency;

    return currencyLabel;
  };

  return implementation;
};
